import type { Message, MessageResponse, MessageSender } from '@/types';

/**
 * Maps a server `MessageResponse` to the UI `Message` shape used inside
 * React Query caches and chat components. Adds derived fields the API
 * doesn't carry (`isAudioReady`, `isTextComplete`, `isAllAudioStreamed`,
 * `ttsEnabled`) and infers `is_audio_message` for legacy rows that lack it.
 *
 * Idempotent enough to call on a value that's already a `Message` — the
 * spread carries existing fields and the derived flags are forced to "true"
 * states that match a fully-loaded historical row.
 */
export function mapToUiMessage(msg: MessageResponse): Message {
  const inferredIsAudio = msg.is_audio_message ?? (msg.sender_type === 'user' && !!msg.audio_url);
  return {
    ...msg,
    sender_type: msg.sender_type as MessageSender,
    is_audio_message: inferredIsAudio,
    ttsEnabled: true,
    isAudioReady: msg.has_audio ?? false,
    isTextComplete: true,
    isAllAudioStreamed: true,
    ...(msg.rating ? { rating: msg.rating } : {}),
  };
}
